import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../store";
import VentureDetailsHeader from "./components/VentureDetailsHeader";
import VentureInfo from "./components/VentureInfo";
import ExploreMoreVentures from "./components/ExploreMoreVentures";
import VentureGallery from "./components/VentureGallery";
import { fetchVenture } from "../../store/slices/ventureSlice";
import LoaderWithContainer from "../../components/base-components/LoaderWithContainer";
import ErrorMessageWithContainer from "../../components/base-components/ErrorWithConatiner";
import NoDataWithContainer from "../../components/base-components/NoDataWithContainer";

const VentureDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { venture, status, error } = useSelector(
    (state: RootState) => state.venture
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchVenture(id));
    }
  }, [id, dispatch]);

  if (status === "loading") return <LoaderWithContainer />;
  if (status === "failed") return <ErrorMessageWithContainer message={error} />;
  if (!venture) {
    return <NoDataWithContainer message={"Venture not found"} />;
  }

  return (
    <section className="global-container">
      {venture && (
        <>
          <VentureDetailsHeader
            title={venture.attributes.title}
            price={venture.attributes.price}
          />

          <VentureGallery images={venture.attributes?.images?.data} />
          <VentureInfo
            info={venture.attributes.description}
            properties={venture.attributes.tags}
          />
          <ExploreMoreVentures />
        </>
      )}
    </section>
  );
};

export default VentureDetails;
